module.exports = __webpack_public_path__ + "img/header_background.94e4d416.png";